import React from "react";
import AuthOTPFlow from "../components/User/AuthOTPHOC/AuthOTPFlow";

import * as Yup from 'yup';
import { AppState } from "../store";
import { connect } from "react-redux";
import { AuthOTPState } from "../store/authOTP/types";
import Styles from './AuthOTP_SA.module.scss';
import classnames from 'classnames';
import { withFlow } from "../components/HOC/withFlow";

const Auth = withFlow(AuthOTPFlow);

interface AuthOTPProps {
  authOTP: AuthOTPState
}

const AuthOTPSchema = Yup.object().shape({
  identification: Yup.string()
    .required('Se requiere rellenar este campo!'),
  otp: Yup.string()
    .required('Se requiere rellenar este campo!')
});

const AuthOTP: React.FC<AuthOTPProps> = (props:AuthOTPProps) => {
  return (
     <div className={classnames(Styles.backGround, "row")}>
        <div className="col-lg-12">
          <Auth validationSchema={AuthOTPSchema} formValues={props.authOTP} />
        </div>
     </div>
  );
};

const mapStateToProps = (state: AppState) => ({
  authOTP: state.authOTP,
  system: state.system
});

export default connect(mapStateToProps)(AuthOTP);

